import "./ShareButton.scss";
import {
  ActionIconText,
  Email,
  Linkedin,
  Meta,
  ShareLink,
  Twitter,
  Whatsapp,
} from "@/index";
import clsx from "clsx";
import { useEffect, useRef, useState } from "react";

type Props = {
  textLabel: string;
  titleShared?: string;
};

const socials = [
  {
    name: "Facebook",
    Icon: <Meta />,
    link: (url: string) =>
      `https://www.facebook.com/sharer/sharer.php?u=${url}`,
  },
  {
    name: "X",
    Icon: <Twitter />,
    link: (url: string, title?: string) =>
      `https://twitter.com/intent/tweet?url=${url}&text=${title}`,
  },
  {
    name: "Email",
    Icon: <Email />,
    link: (url: string, title?: string) =>
      `mailto:?subject=${title}&body=${url}`,
  },
  {
    name: "Linkedin",
    Icon: <Linkedin />,
    link: (url: string, title?: string) =>
      `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}`,
  },
  {
    name: "Whatsapp",
    Icon: <Whatsapp />,
    link: (url: string, title?: string) => {
      const message = `Dai un'occhiata a ${title}! ${url}`;
      return `https://wa.me/?text=${message}`;
    },
  },
];

export const ShareButton = ({ textLabel, titleShared = "" }: Props) => {
  const [openAlert, setopenAlert] = useState(false);
  const toggleButton = () => {
    setopenAlert(!openAlert);
  };

  const onClose = () => {
    setopenAlert(false);
  };

  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return (
    <div
      className={clsx("social-dropdown-container", { open: openAlert })}
      ref={popupRef}
    >
      <ActionIconText
        classNameComponent="toggle-button"
        textLabel={textLabel}
        icon={<ShareLink />}
        handleAction={toggleButton}
        classNameText={"fw-bold fs-7"}
      />
      <div className="social-links">
        {socials.map((social, index) => (
          <button
            key={`socialIcon-${index}`}
            className="social-item"
            onClick={() =>
              window.open(
                `${social.link(encodeURIComponent(window.location.href), encodeURIComponent(titleShared))}`,
              )
            }
            rel="noopener noreferrer"
          >
            {social.Icon}
            {social.name}
          </button>
        ))}
      </div>
    </div>
  );
};
